import { Link, useLocation } from "react-router-dom";
import { business } from "@/data/site";

export const Footer = () => {
  const { pathname } = useLocation();
  const h = (hash) => (pathname === "/" ? hash : "/" + hash);

  return (
    <footer
      data-testid="site-footer"
      className="relative z-10 bg-[#262626] border-t border-white/10"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 pt-10 pb-32 lg:pb-10">
        <a
          href={h("#quote")}
          data-testid="footer-cta"
          className="block font-display font-extrabold uppercase tracking-tighter leading-[0.85] text-[13vw] sm:text-[15vw] lg:text-[13rem] text-white hover:text-[#FF4500] transition-colors"
        >
          Let's Move.
        </a>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-10 border-t border-white/10 pt-10">
          <div>
            <div className="flex items-center gap-3">
              <span className="h-9 w-9 grid place-items-center bg-[#FF4500] text-[#141414] font-display font-extrabold text-lg">
                D
              </span>
              <span className="font-display font-extrabold tracking-tight text-lg leading-none">
                DUKE SUMMERS
                <span className="block text-[10px] tracking-[0.35em] text-[#FF4500] font-bold">
                  MOVING
                </span>
              </span>
            </div>
            <p className="mt-5 text-sm text-neutral-300 max-w-xs leading-relaxed">
              {business.legacyStatement} Professional, dependable moving
              assistance across Dallas–Fort Worth, Memphis, and beyond.
            </p>
          </div>

          <div>
            <p className="text-xs uppercase tracking-widest text-neutral-400 mb-4">Explore</p>
            <ul className="space-y-2 text-sm text-neutral-300">
              <li><a href={h("#services")} className="hover:text-white transition-colors">Services</a></li>
              <li><a href={h("#why")} className="hover:text-white transition-colors">Why Us</a></li>
              <li><a href={h("#about")} className="hover:text-white transition-colors">About</a></li>
              <li><a href={h("#area")} className="hover:text-white transition-colors">Service Area</a></li>
              <li><a href={h("#faq")} data-testid="footer-faq" className="hover:text-white transition-colors">FAQ</a></li>
              <li><a href={h("#contact")} data-testid="footer-contact" className="hover:text-white transition-colors">Contact</a></li>
              <li><Link to="/earn-with-us" data-testid="footer-earn-with-us" className="hover:text-white transition-colors">Earn With Us</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-white/10 pt-8">
          <p className="text-xs text-neutral-400">
            © {new Date().getFullYear()} {business.name}. All rights reserved.
          </p>
          <p className="text-xs text-neutral-400">
            In honor of Samuel Lee "Duke" Summers.
          </p>
        </div>
      </div>
    </footer>
  );
};
